import React from 'react';
import Layout from '../components/Layout';
import './RecentSharesPage.css';

const RecentSharesPage = () => {
  return (
    <Layout>
      <div className="shares-page">
        <div className="shares-header">
          <h1>Recent Shares</h1>
          <p>View and manage your shared try-on images</p>
        </div>

        <div className="coming-soon-card">
          <div className="coming-soon-icon">📤</div>
          <h2>Coming Soon!</h2>
          <p>Social sharing features are currently under development.</p>
          <p>Soon you'll be able to:</p>
          <ul>
            <li>📱 Share to Instagram & TikTok</li>
            <li>🔗 Generate shareable links</li>
            <li>📊 Track share analytics</li>
            <li>💬 Get feedback from friends</li>
            <li>🎨 Add custom watermarks</li>
          </ul>
          <div className="notify-cta">
            <p>Want to be notified when this feature launches?</p>
            <button className="notify-btn">Notify Me</button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RecentSharesPage;